<template>

<div class="card">
  
 <!-- Card content -->
  <div class="card-body">

    <!-- Title -->
    <div class="row">
      <div class="col-md-11">
      <h6 class="card-title">
        <a>{{ pergunta.ordemExibicao}} ) {{ pergunta.titulo }}</a>
        <span v-if="pergunta.obrigatoria" style="color:red;font-weigth:bold">*</span>
      </h6>
      </div>
      <div class="col">
        <!-- <span class="badge badge-success" style="float:rigth"><i class="bi bi-check"></i></span> -->
      </div>
    </div>
    <!-- Text -->
    <p class="card-text" v-if="pergunta.descricao" v-html="pergunta.descricao"></p>
    
<div class="form-group">
    <label for="selectbox_`${pergunta.perguntaId}`"></label>
    
        <select 
            class="form-control"
            v-model="opcaoResposta"  
            @change="responderPergunta(pergunta,$event)" >          
            <option 
                class="opcoes-resposta" 
                :key="opcaoResposta.opcaoRespostaId" 
                v-for="(opcaoResposta) in pergunta.opcoesResposta"
                :id="obterId(opcaoResposta)" 
                :value="opcaoResposta"
                :name="nomeOpcaoResposta">{{opcaoResposta.valor}}</option>
          
        </select>
      </div>
    </div>
   
  </div>


</template>

<script>
import repostaPerguntaMethodsMixin from './ResponderPerguntaMixin'
export default {
  mixins: [repostaPerguntaMethodsMixin],
  name: 'comp-pergunta-select',
  props: ['pergunta', 'permitirResponder'],
  data () {
    return {
      resposta: '',
      opcaoResposta:{}
    }
  },
  computed: {
    nomeOpcaoResposta(){
      return `opcaoResposta_pergunta_${this.pergunta.perguntaId}`
    },
    
    botaoDesabilitado () {
      return this.resposta === '' || !this.permitirResponder
    }
  },
  methods: {
    obterId(opcaoResposta){
      return `opcao_resposta_pergunta_${opcaoResposta.opcaoRespostaPerguntaId}`
    },
    responderPergunta (pergunta, event) {

        const opcaoResposta = this.opcaoResposta;
        const {
          perguntaId, 
          perguntaEncadeadaId, 
          tipoEncadeamentoPergunta,
          encadeamentoPerguntaId,
          sessaoFormularioPerguntaId,
          sessaoFormularioId,
          valor
        } = opcaoResposta;

      this.removerTodasRespostasPergunta(sessaoFormularioPerguntaId);
      this.responderPerguntaMixin({pergunta, opcaoResposta});

      //verificar se existe pergunta encadeada a resposta
      //if(perguntaEncadeadaId && Number(perguntaEncadeadaId) > 0)   
      const configPerguntaEncadeada = 
        {
          perguntaId,
          perguntaEncadeadaId,
          tipoEncadeamentoPergunta,
          encadeamentoPerguntaId, 
          valor,
          sessaoFormularioPerguntaId,
          sessaoFormularioId
       }   
      
      this.verificarPerguntaEncadeada(configPerguntaEncadeada);
    }
  },
  mounted () {
    
  }
}
</script>

<style>
  .opcoes-resposta{
    font-size: 12pt;
  }
</style>



// WEBPACK FOOTER //
// src/components/PerguntasComponent/PerguntaTipoSelect.vue